<script>
    import { Row, Col, Button } from 'sveltestrap'
    import { InputDate, InputText, Select } from '@fno/component2/form.js'
    import Icon from 'svelte-awesome'
    import { plus } from 'svelte-awesome/icons'
    import FormAlerts from '../FormAlerts.svelte'
    import FormSavingButtons from '../FormSavingButtons.svelte'
    import UserInfo from './UserInfo.svelte'
    import timezones from 'fanx-schema/value/timezone'

    export let context
    export let saving
    export let schoolId

    $: selectableTimezones = Object.keys(timezones).map((id) => ({
        id,
        name: timezones[id]
    }))

    const addBlankUser = () => {
        const blankUser = {
            $create: true,
            id: context.form.users.length,
            attributes: {
                firstname: '',
                lastname: '',
                email: '',
                phoneNumber: '',
                sports: [ '*' ],
                roles: [ 'admin' ],
                schoolIds: [ schoolId ]
            }
        }

        if (context.school && context.school.organizationId) {
            blankUser.organizationIds = [ context.school.organizationId ]
        }

        context.form.users = [ ...context.form.users, blankUser ]
    }
</script>

<h1>Contact Information</h1>

<p>Let's ensure we have the correct contact information on file.</p>

<Row class="mb-3">
    <Col xs="12" md="8" lg="6" xl="5">
        <InputText
            label="Client Name"
            placeholder="School of Hard Knocks"
            {context}
            formKey="school"
            keypath="attributes.name"
            bind:value={context.form.school.attributes.name}
            on:change
        />
    </Col>
    <Col xs="12" md="8" lg="6" xl="5">
        <Select
            label="Timezone"
            {context}
            required
            includeDefaultValue
            options={selectableTimezones}
            formKey="school"
            keypath="attributes.timezone"
            bind:value={context.form.school.attributes.timezone}
            on:change
        />
    </Col>
</Row>

<h2>General Contact Information</h2>

{#each context.form.users as user, index (user.id)}
    <Row class="mb-3">
        <Col>
            <UserInfo bind:context formKey="users" {index} on:change />
        </Col>
    </Row>
{/each}

<Row>
    <Col>
        <p>
            <Button on:click={addBlankUser}>
                Add another contact
                <Icon data={plus} />
            </Button>
        </p>
    </Col>
</Row>

<h2>Launch Date</h2>

<p>
    Please enter your desired app launch date. NOTE: Contract and Apple Developer account steps should be completed 2
    weeks before the desired launch date.
</p>

<Row>
    <Col xs="6">
        <InputDate
            label="Date (mm/dd/yyyy)"
            {context}
            formKey="schoolOnboarding"
            keypath="attributes.steps.CLIENT_KICK_OFF.launchDate"
            bind:value={context.form.schoolOnboarding.attributes.steps.CLIENT_KICK_OFF.launchDate}
            on:change
        />
    </Col>
</Row>

<FormAlerts bind:alerts={context.alerts} />

<FormSavingButtons firstPage {context} {saving} on:save on:nextStepClicked on:previousStepClicked />
